<template>
  <div>
    <v-card>
      <v-card-text>
        <v-tabs>
          <v-tab ripple @click="refreshPosting">
            Posting
          </v-tab>
          <v-tab ripple @click="refreshPosted">
            Posted Today
          </v-tab>
          <v-tab ripple @click="refreshPostMap" v-if="checkAccess(['travelPostMap'])">
            Posting Mapping
          </v-tab>
          <v-tab-item>
          <v-layout row wrap>
            <v-flex xs12>
              <form>
                <v-expansion-panel expand :value="[true]" class="mt-3">
                  <v-expansion-panel-content>
                    <div slot="header">
                      <v-icon>mdi-filter-variant</v-icon> Filters
                    </div>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="params.intermediaries" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="params.products" v-model="filters.product" :label="filtersLabel.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="filtersLabel.product" :error-messages="errors.collect('product')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="params.schemes" v-model="filters.scheme" :label="filtersLabel.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="filtersLabel.scheme" :error-messages="errors.collect('scheme')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="params.plans" v-model="filters.plan" :label="filtersLabel.plan" item-text="label" item-value="value" data-vv-name="plan" :data-vv-as="filtersLabel.plan" :error-messages="errors.collect('plan')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.appName" :label="filtersLabel.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="filtersLabel.appName" v-validate="'name|max:60'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="params.travelType" v-model="filters.travelType" :label="filtersLabel.travelType" item-text="label" item-value="value" data-vv-name="travelType" :data-vv-as="filtersLabel.travelType" :error-messages="errors.collect('travelType')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="params.tripType" v-model="filters.tripType" :label="filtersLabel.tripType" item-text="label" item-value="value" data-vv-name="tripType" :data-vv-as="filtersLabel.tripType" :error-messages="errors.collect('tripType')" clearable></v-autocomplete>
                            </v-flex>
                          </v-layout>
                          <transition name="slide-x-transition" mode="out-in">
                            <v-layout row wrap v-if="showDetailFilters">
                              <v-flex xl3 lg4 xs6>
                                <v-text-field v-model="filters.appNricPassport" :label="filtersLabel.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="filtersLabel.appNricPassport" v-validate="'alpha_num|max:60'"></v-text-field>
                              </v-flex>
                              <v-flex xl3 lg4 xs6>
                                <v-text-field v-model="filters.coyName" :label="filtersLabel.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="filtersLabel.coyName" v-validate="'name|max:60'"></v-text-field>
                              </v-flex>
                              <v-flex xl3 lg4 xs6>
                                <v-text-field v-model="filters.usrRefId" :label="filtersLabel.usrRefId" :error-messages="errors.collect('usrRefId')" data-vv-name="usrRefId" :data-vv-as="filtersLabel.usrRefId" v-validate="'entry|max:60'"></v-text-field>
                              </v-flex>
                              <v-flex xl3 lg4 xs6></v-flex>
                              <v-flex xl3 lg4 xs6>
                                <cal-picker v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                              </v-flex>
                              <v-flex xl3 lg4 xs6>
                                <cal-picker v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                              </v-flex>
                            </v-layout>
                          </transition>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </form>
            </v-flex>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
            <v-flex xs12>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                  <v-btn color="secondary" class="white--text" slot="activator">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                  <v-card>
                    <v-card-text>
                      <template v-if="columns.length > 0">
                        <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                      </template>
                      <template v-else>
                        No column found
                      </template>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="mt-2">
              <v-data-table :headers="listHeaders" :items="items" item-key="proposalNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText" v-model="selected" select-all>
                <template slot="items" slot-scope="props">
                  <td width="50px">
                    <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
                  </td>
                  <td v-for="column in selectedColumns" :key="column">
                    {{props.item[column]}}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <div class="pt-2">
              <v-btn color="primary" @click="doPromptPost" :loading="loading">
                Post Selected
                <v-icon right>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            <confirm v-model="promptPost" @ok="doPost">
              Are you sure you want to post selected record(s)?
            </confirm>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <travel-quote-posted v-model="loadPosted"></travel-quote-posted>
        </v-tab-item>
        <v-tab-item v-if="checkAccess(['travelPostMap'])">
          <travel-post-map v-model="loadPostMap"></travel-post-map>
        </v-tab-item>
      </v-tabs>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import clone from 'clone'
import { postingMixin } from '../shared/postingMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import toDate from 'date-fns/toDate'
import { removeTime, setEndTime, formatDisplayDateTime2 } from '@/utils/date'
import { tripType, travelType } from '@/const/underwriting/travel'
import TravelQuotePosted from './TravelQuotePosted'
import TravelPostMap from './TravelPostMap'

export default {
  data() {
    return {
      columns: [
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Product', value: 'product' },
        { text: 'Scheme', value: 'scheme' },
        { text: 'Plan', value: 'plan' },
        { text: 'Intermediary', value: 'intermediary' },
        { text: 'Premium', value: 'premium' },
        { text: 'Applicant Name', value: 'appName' },
        { text: 'Company Name', value: 'coyName' },
        { text: 'NRIC/Passport', value: 'appNricPassport' },
        { text: 'Travel Type', value: 'travelType' },
        { text: 'Trip Type', value: 'tripType' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'User Ref Id', value: 'usrRefId' }
      ],
      selectedColumns: ['proposalNo', 'intermediary', 'product', 'scheme', 'appName', 'premium', 'createdDate'],
      filtersLabel: {
        proposalNo: 'Proposal No.',
        intermediary: 'Intermediary',
        product: 'Product',
        scheme: 'Scheme',
        plan: 'Plan',
        appName: 'Applicant Name',
        coyName: 'Company Name',
        appNricPassport: 'NRIC/Passport',
        tripType: 'Trip Type',
        travelType: 'Travel Type',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To',
        usrRefId: 'User Ref Id'
      },
      filters: {
        proposalNo: null,
        intermediary: null,
        product: null,
        plan: null,
        scheme: null,
        appName: null,
        coyName: null,
        appNricPassport: null,
        tripType: null,
        travelType: null,
        entryFrom: null,
        entryTo: null,
        usrRefId: null
      },
      params: {
        intermediaries: [],
        products: [],
        plans: [],
        tripType: [],
        travelType: [],
        status: []
      },
      showDetailFilters: false,
      promptPost: false,
      loadPosted: false,
      loadPostMap: false
    }
  },
  methods: {
    refreshPosting() {
      this.fetchData(false)
      this.loadPosted = false
      this.loadPostMap = false
    },
    refreshPosted() {
      this.loadPosted = true
      this.loadPostMap = false
    },
    refreshPostMap() {
      this.loadPosted = false
      this.loadPostMap = true
    },
    async fetchData(options) {
      if (this.apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage,
            options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }

          const result = await this.$http.get(filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))

          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((quote) => {
                const convertQuote = {
                  proposalNo: quote.proposalNo,
                  product: quote.productName,
                  intermediary: quote.intermediaryName,
                  scheme: quote.schemeName,
                  plan: quote.planName,
                  premium: this.formatNumber(quote.premium),
                  appName: quote.appName,
                  coyName: quote.coyName,
                  polNo: quote.polNo,
                  appNricPassport: quote.appNricPassport,
                  travelType: quote.travelType ? travelType[quote.travelType] : '',
                  tripType: quote.tripType ? tripType[quote.tripType] : '',
                  createdDate: this.formatDate(toDate(quote.createdDate)),
                  usrRefId: quote.usrRefId
                }
                this.items.push(convertQuote)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$set(this.params, 'intermediaries', result.data.intermediaries)
              this.$set(this.params, 'products', result.data.products)
              this.$set(this.params, 'plans', result.data.plans)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doPromptPost() {
      if (this.selected.length > 0) {
        this.promptPost = true
      } else {
        this.$snotify.warning('Please select record(s) to be posted.')
      }
    },
    async doPost() {
      const apiURI = this.postingState.menu.postSelected
      if (apiURI) {
        this.loading = true
        let postForm = []
        this.selected.map(select => {
          postForm.push(select.proposalNo)
        })
        try {
          const result = await this.$http.post(apiURI, postForm)
          this.notify(result.data)

          // Reinit
          this.fetchData(false)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.loading = false
        }
        this.selected = []
      }
    },
    doClearFilters() {
      this.filters.proposalNo = null
      this.filters.intermediary = null
      this.filters.product = null
      this.filters.plan = null
      this.filters.appName = null
      this.filters.coyName = null
      this.filters.tripType = null
      this.filters.travelType = null
      this.filters.appNricPassport = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  created() {
    this.apiUrl = this.postingState.menu.travel

    // Default some params from const
    Object.keys(travelType).forEach((key) => {
      this.params.travelType.push({
        label: travelType[key],
        value: key
      })
    })

    Object.keys(tripType).forEach((key) => {
      this.params.tripType.push({
        label: tripType[key],
        value: key
      })
    })
  },
  mixins: [
    postingMixin
  ],
  components: {
    TravelQuotePosted,
    TravelPostMap
  }
}
</script>

<style lang="scss">
</style>
